export default "__VITE_ASSET__59756b82__"